import { CartNav } from './cart-nav';
import { GlobalSearch } from './global-search/global-search';
import { SecondaryNavLinks } from './secondary-nav-links';

export const SecondaryNav = (): React.JSX.Element => {
  return (
    <div className="flex items-center gap-3">
      <SecondaryNavLinks />
      <GlobalSearch />
      <CartNav />
    </div>
  );
};
